import { ProvidedNativeFunctions } from './Interfaces/ProvidedNativeFunctions';
import  CLSyncNativeBridge  from './CLSyncNativeBridge';
import { generateCallBackId } from './generateCallBackId';

type MapNativeResponse<Return> = (...argumentsFromNative: any[]) => Return;
const callbacks = new Map<string, Function>();

function continueNativeCallBack(callbackId: string, ...params: any[]): void {
    if(!callbacks.has(callbackId)) {
        //console.log("Callback not found");
        return;
    }
    
    const callback = callbacks.get(callbackId);
    callback(...params);
    callbacks.delete(callbackId);
}

/**
 * Invokes a native function synchronously via the bridge 
 * @param functionName - Name of the function to be invoked
 * @param params - Optional parameters to be passed to the native function
 */
export function callSyncNative(functionName: keyof ProvidedNativeFunctions, ...params: any[]): void {
        const bridge = new CLSyncNativeBridge();
        const fn = bridge[functionName];
        fn(...params);
}

/**
 * Invokes a native function asynchronously via the bridge
 * @param functionName - Name of the function to be invoked
 * @param mapResponse - A function to map the resolved result according to calling function's convenience
 * @param params - Optional parameters to pass to the native function
 */
export function callAsyncNative<Return>(functionName: keyof ProvidedNativeFunctions, mapResponse: MapNativeResponse<Return> = value => value, ...params: any[]): Promise<Return> {
    return new Promise<Return>((resolve) => {
        //console.log("Calling function "+ functionName + " with params "+JSON.stringify(params)) 
        (window as any)[`${functionName}_complete`] = continueNativeCallBack;
        const bridge = new CLSyncNativeBridge();
        const callbackId = generateCallBackId();
        callbacks.set(callbackId, (...args: any[]) => {
            resolve(mapResponse(...args));
        });
        params.push(callbackId);
        const fn = bridge[functionName];
        fn(...params);
        });
}